import _defineProperty from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["children", "className"],
    _excluded2 = ["label", "placement", "spacing", "children", "className", "__css"],
    _excluded3 = ["isDisabled", "isLoading", "isActive", "children", "leftIcon", "rightIcon", "loadingText", "iconSpacing", "type", "spinner", "spinnerPlacement", "className", "as"],
    _excluded4 = ["size", "colorScheme", "variant", "className", "spacing", "isAttached", "isDisabled"],
    _excluded5 = ["icon", "children", "isRound", "aria-label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// ../../../react-shim.js
import React from "react"; // src/button.tsx

import { useMergeRefs } from "@chakra-ui/react-use-merge-refs";
import { chakra as chakra3, forwardRef, omitThemingProps, useStyleConfig } from "@chakra-ui/system"; // ../../utilities/shared-utils/src/index.ts

var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(" ");
};

var dataAttr = function dataAttr(condition) {
  return condition ? "" : void 0;
}; // src/button.tsx


import { useMemo as useMemo2 } from "react"; // src/button-context.ts

import { createContext } from "@chakra-ui/react-context";

var _createContext = createContext({
  strict: false,
  name: "ButtonGroupContext"
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    ButtonGroupProvider = _createContext2[0],
    useButtonGroup = _createContext2[1]; // src/button-icon.tsx


import { chakra } from "@chakra-ui/system";
import { cloneElement, isValidElement } from "react";

function ButtonIcon(props) {
  var children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var _children = isValidElement(children) ? cloneElement(children, {
    "aria-hidden": true,
    focusable: false
  }) : children;

  var _className = cx("chakra-button__icon", className);

  return /* @__PURE__ */React.createElement(chakra.span, _objectSpread(_objectSpread({
    display: "inline-flex",
    alignSelf: "center",
    flexShrink: 0
  }, rest), {}, {
    className: _className
  }), _children);
}

ButtonIcon.displayName = "ButtonIcon"; // src/button-spinner.tsx

import { Spinner } from "@chakra-ui/spinner";
import { chakra as chakra2 } from "@chakra-ui/system";
import { useMemo } from "react";

function ButtonSpinner(props) {
  var label = props.label,
      placement = props.placement,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
      _props$children = props.children,
      children = _props$children === void 0 ? /* @__PURE__ */React.createElement(Spinner, {
    color: "currentColor",
    width: "1em",
    height: "1em"
  }) : _props$children,
      className = props.className,
      __css = props.__css,
      rest = _objectWithoutProperties(props, _excluded2);

  var _className = cx("chakra-button__spinner", className);

  var marginProp = placement === "start" ? "marginEnd" : "marginStart";
  var spinnerStyles = useMemo(function () {
    var _objectSpread2;

    return _objectSpread((_objectSpread2 = {
      display: "flex",
      alignItems: "center",
      position: label ? "relative" : "absolute"
    }, _defineProperty(_objectSpread2, marginProp, label ? spacing : 0), _defineProperty(_objectSpread2, "fontSize", "1em"), _defineProperty(_objectSpread2, "lineHeight", "normal"), _objectSpread2), __css);
  }, [__css, label, marginProp, spacing]);
  return /* @__PURE__ */React.createElement(chakra2.div, _objectSpread(_objectSpread({
    className: _className
  }, rest), {}, {
    __css: spinnerStyles
  }), children);
}

ButtonSpinner.displayName = "ButtonSpinner"; // src/use-button-type.tsx

import { useCallback, useState } from "react";

function useButtonType(value) {
  var _useState = useState(!value),
      _useState2 = _slicedToArray(_useState, 2),
      isButton = _useState2[0],
      setIsButton = _useState2[1];

  var refCallback = useCallback(function (node) {
    if (!node) return;
    setIsButton(node.tagName === "BUTTON");
  }, []);
  var type = isButton ? "button" : void 0;
  return {
    ref: refCallback,
    type: type
  };
} // src/button.tsx


var Button = forwardRef(function (props, ref) {
  var group = useButtonGroup();
  var styles = useStyleConfig("Button", _objectSpread(_objectSpread({}, group), props));

  var _omitThemingProps = omitThemingProps(props),
      _omitThemingProps$isD = _omitThemingProps.isDisabled,
      isDisabled = _omitThemingProps$isD === void 0 ? group == null ? void 0 : group.isDisabled : _omitThemingProps$isD,
      isLoading = _omitThemingProps.isLoading,
      isActive = _omitThemingProps.isActive,
      children = _omitThemingProps.children,
      leftIcon = _omitThemingProps.leftIcon,
      rightIcon = _omitThemingProps.rightIcon,
      loadingText = _omitThemingProps.loadingText,
      _omitThemingProps$ico = _omitThemingProps.iconSpacing,
      iconSpacing = _omitThemingProps$ico === void 0 ? "0.5rem" : _omitThemingProps$ico,
      type = _omitThemingProps.type,
      spinner = _omitThemingProps.spinner,
      _omitThemingProps$spi = _omitThemingProps.spinnerPlacement,
      spinnerPlacement = _omitThemingProps$spi === void 0 ? "start" : _omitThemingProps$spi,
      className = _omitThemingProps.className,
      as = _omitThemingProps.as,
      rest = _objectWithoutProperties(_omitThemingProps, _excluded3);

  var buttonStyles = useMemo2(function () {
    var _focus = _objectSpread(_objectSpread({}, styles == null ? void 0 : styles["_focus"]), {}, {
      zIndex: 1
    });

    return _objectSpread(_objectSpread({
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none"
    }, styles), !!group && {
      _focus: _focus
    });
  }, [styles, group]);

  var _useButtonType = useButtonType(as),
      _ref = _useButtonType.ref,
      defaultType = _useButtonType.type;

  var contentProps = {
    rightIcon: rightIcon,
    leftIcon: leftIcon,
    iconSpacing: iconSpacing,
    children: children
  };
  return /* @__PURE__ */React.createElement(chakra3.button, _objectSpread({
    disabled: isDisabled || isLoading,
    ref: useMergeRefs(ref, _ref),
    as: as,
    type: type !== null && type !== void 0 ? type : defaultType,
    "data-active": dataAttr(isActive),
    "data-loading": dataAttr(isLoading),
    __css: buttonStyles,
    className: cx("chakra-button", className)
  }, rest), isLoading && spinnerPlacement === "start" && /* @__PURE__ */React.createElement(ButtonSpinner, {
    className: "chakra-button__spinner--start",
    label: loadingText,
    placement: "start",
    spacing: iconSpacing
  }, spinner), isLoading ? loadingText || /* @__PURE__ */React.createElement(chakra3.span, {
    opacity: 0
  }, /* @__PURE__ */React.createElement(ButtonContent, _objectSpread({}, contentProps))) : /* @__PURE__ */React.createElement(ButtonContent, _objectSpread({}, contentProps)), isLoading && spinnerPlacement === "end" && /* @__PURE__ */React.createElement(ButtonSpinner, {
    className: "chakra-button__spinner--end",
    label: loadingText,
    placement: "end",
    spacing: iconSpacing
  }, spinner));
});
Button.displayName = "Button";

function ButtonContent(props) {
  var leftIcon = props.leftIcon,
      rightIcon = props.rightIcon,
      children = props.children,
      iconSpacing = props.iconSpacing;
  return /* @__PURE__ */React.createElement(React.Fragment, null, leftIcon && /* @__PURE__ */React.createElement(ButtonIcon, {
    marginEnd: iconSpacing
  }, leftIcon), children, rightIcon && /* @__PURE__ */React.createElement(ButtonIcon, {
    marginStart: iconSpacing
  }, rightIcon));
} // src/button-group.tsx


import { chakra as chakra4, forwardRef as forwardRef2 } from "@chakra-ui/system";
import { useMemo as useMemo3 } from "react";
var ButtonGroup = forwardRef2(function ButtonGroup2(props, ref) {
  var size = props.size,
      colorScheme = props.colorScheme,
      variant = props.variant,
      className = props.className,
      _props$spacing2 = props.spacing,
      spacing = _props$spacing2 === void 0 ? "0.5rem" : _props$spacing2,
      isAttached = props.isAttached,
      isDisabled = props.isDisabled,
      rest = _objectWithoutProperties(props, _excluded4);

  var _className = cx("chakra-button__group", className);

  var context = useMemo3(function () {
    return {
      size: size,
      colorScheme: colorScheme,
      variant: variant,
      isDisabled: isDisabled
    };
  }, [size, colorScheme, variant, isDisabled]);
  var groupStyles = {
    display: "inline-flex"
  };

  if (isAttached) {
    groupStyles = _objectSpread(_objectSpread({}, groupStyles), {}, {
      "> *:first-of-type:not(:last-of-type)": {
        borderEndRadius: 0
      },
      "> *:not(:first-of-type):not(:last-of-type)": {
        borderRadius: 0
      },
      "> *:not(:first-of-type):last-of-type": {
        borderStartRadius: 0
      }
    });
  } else {
    groupStyles = _objectSpread(_objectSpread({}, groupStyles), {}, {
      "& > *:not(style) ~ *:not(style)": {
        marginStart: spacing
      }
    });
  }

  return /* @__PURE__ */React.createElement(ButtonGroupProvider, {
    value: context
  }, /* @__PURE__ */React.createElement(chakra4.div, _objectSpread({
    ref: ref,
    role: "group",
    __css: groupStyles,
    className: _className,
    "data-attached": isAttached ? "" : void 0
  }, rest)));
});
ButtonGroup.displayName = "ButtonGroup"; // src/icon-button.tsx

import { forwardRef as forwardRef3 } from "@chakra-ui/system";
import { cloneElement as cloneElement2, isValidElement as isValidElement2 } from "react";
var IconButton = forwardRef3(function (props, ref) {
  var icon = props.icon,
      children = props.children,
      isRound = props.isRound,
      ariaLabel = props["aria-label"],
      rest = _objectWithoutProperties(props, _excluded5);

  var element = icon || children;

  var _children = isValidElement2(element) ? cloneElement2(element, {
    "aria-hidden": true,
    focusable: false
  }) : null;

  return /* @__PURE__ */React.createElement(Button, _objectSpread({
    padding: "0",
    borderRadius: isRound ? "full" : void 0,
    ref: ref,
    "aria-label": ariaLabel
  }, rest), _children);
});
IconButton.displayName = "IconButton";
export { Button, ButtonGroup, ButtonSpinner, IconButton, useButtonGroup };